/**
 *
  This was used to limit search but is now only used for initial search dates.
  https://jira.verbinteractive.com/browse/RCL223-23
 */

export const supportedShipsByBrand = {
  // for Royal Caribbean
  R: {
    AD: { startDate: '2022-04-11' }, // Adventure
    AL: { startDate: '2022-04-30' }, // Allure
    AN: { startDate: '2022-03-27' }, // Anthem
    BR: { startDate: '2022-11-05' }, // Brilliance Of The Seas
    EN: { startDate: '2022-05-12' }, // Enchantment Of The Seas
    EX: { startDate: '2022-06-23' }, // Explorer Of The Seas
    FR: { startDate: '2022-04-04' }, // Freedom
    GR: { startDate: '2022-04-28' }, // Grandeur Of The Seas
    HM: {}, // Harmony
    ID: { startDate: '2022-04-15' }, // Independence
    LB: { startDate: '2022-04-17' }, // Liberty
    MA: {}, // Mariner
    NV: { startDate: '2022-03-07' }, // Navigator
    OA: {}, // Oasis
    OV: { startDate: '2022-05-05' }, // Ovation
    OY: {}, // Odyssey - start date not provided
    QN: { startDate: '2022-05-16' }, // Quantum
    RD: { startDate: '2022-11-12' }, // Radiance
    SC: { startDate: '2022-11-03' }, // Spectrum of the Seas
    SY: {}, // Symphony
    VY: { startDate: '2022-11-20' }, // Voyager
    WN: { startDate: '2022-12-04' }, // Wonder of the Seas
    IC: { startDate: '2024-01-27' },
    UT: { startDate: '2024-07-01' }
  },
  // for Celebrity
  C: {
    AT: { startDate: '2022-07-14' }, // Celebrity Ascent (not in our CMS)
    AX: {}, // Celebrity Apex
    BY: {}, // Beyond
    EC: { startDate: '2022-07-13' }, // Celebrity Eclipse
    EG: {}, // Edge
    EQ: {}, // Equinox
    CS: { startDate: '2022-09-25' }, // Celebrity Constellation
    IN: { startDate: '2022-05-24' }, // Celebrity Infinity
    ML: {}, // Millennium
    RF: { startDate: '2022-04-02' }, // Reflection
    SI: { startDate: '2022-03-18' }, // Silhouette
    SL: { startDate: '2022-10-15' }, // Celebrity Solstice
    SM: { startDate: '2022-10-27' }, // Celebrity Summit
  },
}
